import React from "react"
import HeadTitle from "../../Common/HeadTitle/HeadTitle"
import ContactFrom from "./ContactFrom"

const Contact = () => {
  return (
    <>
      <HeadTitle />
      <ContactFrom />
    </>
  )
}

export default Contact
